/** A classic four-generation pedigree chart, drawn like an old printed family register. */
const BOX_W = 132;
const BOX_H = 40;

const COLS = [
  { x: 6, people: [{ name: 'Yourself', note: 'b. 1984' }] },
  { x: 168, people: [{ name: 'Father', note: 'b. 1951' }, { name: 'Mother', note: 'b. 1954' }] },
  {
    x: 330,
    people: [
      { name: 'Grandfather', note: 'b. 1922' },
      { name: 'Grandmother', note: 'b. 1925' },
      { name: 'Grandfather', note: 'b. 1919' },
      { name: 'Grandmother', note: '? unknown', missing: true },
    ],
  },
];

const HEIGHT = 340;

function rows(count) {
  const slot = HEIGHT / count;
  return Array.from({ length: count }, (_, i) => slot * i + slot / 2);
}

export default function HeroArt() {
  const ys = COLS.map((c) => rows(c.people.length));

  return (
    <figure className="pedigree" aria-hidden="true">
      <figcaption className="pedigree__title">
        <span>Pedigree Chart</span>
        <small>No. 1 — Family Register</small>
      </figcaption>
      <svg viewBox={`0 0 470 ${HEIGHT}`} className="pedigree__svg">
        {COLS.slice(0, -1).map((col, ci) =>
          col.people.map((_, pi) => {
            const x1 = col.x + BOX_W;
            const y = ys[ci][pi];
            const nextX = COLS[ci + 1].x;
            const midX = (x1 + nextX) / 2;
            const yTop = ys[ci + 1][pi * 2];
            const yBot = ys[ci + 1][pi * 2 + 1];
            return (
              <path
                key={`${ci}-${pi}`}
                className="pedigree__line"
                d={`M${x1} ${y}H${midX}M${midX} ${yTop}V${yBot}M${midX} ${yTop}H${nextX}M${midX} ${yBot}H${nextX}`}
              />
            );
          })
        )}
        {COLS.map((col, ci) =>
          col.people.map((p, pi) => {
            const y = ys[ci][pi] - BOX_H / 2;
            return (
              <g key={`${ci}-${pi}`} className={`pedigree__box ${p.missing ? 'is-missing' : ''} ${ci === 0 ? 'is-root' : ''}`}>
                <rect x={col.x} y={y} width={BOX_W} height={BOX_H} />
                <text x={col.x + 10} y={y + 17} className="pedigree__name">
                  {p.name}
                </text>
                <text x={col.x + 10} y={y + 32} className="pedigree__note">
                  {p.note}
                </text>
              </g>
            );
          })
        )}
      </svg>
      <div className="pedigree__stamp">
        <strong>Records found</strong>
        <span>3 census · 1 parish</span>
      </div>
    </figure>
  );
}
